/**
 * Rotate stacked announcement bars inside [data-sk-ann-rotate].
 * Uses display show/hide (not opacity) to avoid theme CSS fights.
 */
(function () {
  'use strict';

  function slidesOf(root) {
    return Array.prototype.slice.call(
      root.querySelectorAll(':scope > .announcement-bar, :scope > [data-bar-id]')
    );
  }

  function paint(slide, on) {
    slide.classList.toggle('is-ann-active', on);
    slide.setAttribute('aria-hidden', on ? 'false' : 'true');
    // display:none/block — more reliable than opacity against theme styles
    slide.style.setProperty('display', on ? 'block' : 'none', 'important');
  }

  function setActive(root, index) {
    var slides = slidesOf(root).filter(function (el) {
      // Keep bars that were not permanently dismissed via the dismiss script
      // (dismiss sets display:none without is-ann-active control — detect via data attr)
      return el.getAttribute('data-ann-dismissed') !== '1';
    });
    if (!slides.length) return 0;
    var i = ((index % slides.length) + slides.length) % slides.length;
    slides.forEach(function (slide, idx) {
      paint(slide, idx === i);
    });
    root.setAttribute('data-active-index', String(i));
    return i;
  }

  function init(root) {
    if (root.getAttribute('data-sk-ann-ready')) return;
    root.setAttribute('data-sk-ann-ready', '1');

    var slides = slidesOf(root);
    // Dismiss button removed — rotation always includes all slides.
    if (slides.length < 2) {
      if (slides[0]) paint(slides[0], true);
      return;
    }

    var seconds = parseInt(root.getAttribute('data-interval') || '6', 10);
    if (Number.isNaN(seconds) || seconds < 3) seconds = 6;
    var intervalMs = seconds * 1000;
    var index = 0;
    var timer = null;
    var manuallyPaused = false;
    var toggle = root.querySelector('[data-sk-ann-toggle]');
    var reduceMotion =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    manuallyPaused = reduceMotion;

    index = setActive(root, 0);

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function tick() {
      if (document.hidden || root.matches(':hover') || root.matches(':focus-within')) return;
      index += 1;
      index = setActive(root, index);
    }

    function start() {
      if (manuallyPaused || root.matches(':focus-within')) return;
      stop();
      timer = setInterval(tick, intervalMs);
    }

    function updateToggle() {
      if (!toggle) return;
      var paused = manuallyPaused;
      toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
      toggle.setAttribute('aria-label', paused ? 'Play announcements' : 'Pause announcements');
      toggle.textContent = paused ? 'Play' : 'Pause';
    }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', function (event) {
      if (event.relatedTarget && root.contains(event.relatedTarget)) return;
      start();
    });
    if (toggle) {
      toggle.addEventListener('click', function () {
        manuallyPaused = !manuallyPaused;
        updateToggle();
        if (manuallyPaused) stop();
        else start();
      });
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    updateToggle();
    start();
  }

  function boot() {
    document.querySelectorAll('[data-sk-ann-rotate]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
